import styled, { css } from 'styled-components';

const Collection = styled.div`
  ${(props) => {
    const spacing = props.spacing || '0.5rem';
    if (props.stacked) {
      const overlap = props.overlap || '1rem';
      return css`
        display: inline-flex;
        & > * + * {
          margin-left: -${overlap};
        }
      `;
    }
    return css`
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: ${spacing};
    `;
  }}
`;

export default Collection;
